import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function VolumeLowIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m16.952 8.92245c1.0351.63229 1.7261 1.77265 1.7261 3.07445 0 1.3016-.6911 2.4415-1.7261 3.0738l-1.0002-1.0002c.8086-.3411 1.3763-1.1409 1.3763-2.0736 0-.9329-.5676-1.7332-1.3763-2.07425z" />
        <path d="m8.92813 15.1469h-3c-.33138 0-.60001-.2683-.60001-.5996v-5.10083c0-.33138.26863-.5996.60001-.5996h3s1.81677-1.09348 2.99997-2.25c.568-.55516 1.2958-1.42547 1.8923-2.17129.3607-.45096 1.1077-.19972 1.1077.37774v14.39528c0 .5766-.7444.8278-1.1048.3777-.6022-.7521-1.3364-1.6311-1.8952-2.1794-1.2026-1.1802-2.99997-2.25-2.99997-2.25z" />
      </g>
    </SVGWrapper>

  );
}

export default VolumeLowIcon;
